import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Editor = lazy(() => import('./pages/Editor'));
const Login = lazy(() => import('./pages/Login'));
import AuthLayout from './layouts/AuthLayout';
import { supabase } from './lib/supabase';
import { useAuthStore } from './store/auth';
const Subscription = lazy(() => import('./pages/Subscription'));
const FileUpload = lazy(() => import('./pages/FileUpload'));
const Homepage = lazy(() => import('./pages/Homepage'));
const Profile = lazy(() => import('./pages/Profile'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Signup = lazy(() => import('./pages/Signup'));
const Topup = lazy(() => import('./pages/Topup'));
const PaymentSuccess = lazy(() => import('./pages/PaymentSuccess'));
const AdminDashboard = lazy(() => import('./pages/admin/Dashboard'));
import { ErrorBoundary } from './components/ErrorBoundary';
import { LoadingSpinner } from './components/LoadingSpinner';
import { AICreditProvider } from './features/ai-credit/context/AICreditProvider';
import './styles/globals.css';

function App() {
  const { setUser, checkSession, isLoading } = useAuthStore();

  React.useEffect(() => {
    // Periksa sesi penguna yang aktif
    checkSession();

    // Mendengarkan perubahan status auth (log in, log out, dll)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, [setUser, checkSession]);

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  return (
    <ErrorBoundary>
      <AICreditProvider>
        <BrowserRouter>
          <Suspense fallback={<LoadingSpinner fullScreen />}>
            <Routes>
            {/* Public routes */}
            <Route path="/" element={<Homepage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* Protected routes */}
            <Route element={<AuthLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/editor/:id?" element={<Editor />} />
              <Route path="/file-upload" element={<FileUpload />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/topup" element={<Topup />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
            </Route>

            {/* Admin routes */}
            <Route 
              path="/admin" 
              element={
                <ErrorBoundary>
                  <AdminDashboard />
                </ErrorBoundary>
              } 
            />

            {/* Catch all route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
      </AICreditProvider>
    </ErrorBoundary>
  );
}

export default App;